/**
 * DOM element caching for performance optimization
 */

let cachedGanttContainer = null;
let cachedParentContainer = null;

/**
 * Cache gantt container elements to avoid repeated queries
 */
export function cacheGanttContainers() {
  if (!cachedGanttContainer) {
    cachedGanttContainer =
      document.getElementById('scheduleContainer') ||
      document.querySelector('.gantt-container') ||
      document.querySelector('.new-gantt-chart');

    if (cachedGanttContainer && cachedGanttContainer.parentElement) {
      const parent = cachedGanttContainer.parentElement;
      if (parent.className.includes('gantt-container')) {
        cachedParentContainer = parent;
      }
    }
  }
  return cachedGanttContainer;
}

/**
 * Get cached parent container
 */
export function getCachedParentContainer() {
  return cachedParentContainer;
}

/**
 * Clear cached containers (for cleanup)
 */
export function clearCache() {
  cachedGanttContainer = null;
  cachedParentContainer = null;
}

/**
 * Re-cache containers (for resize events)
 */
export function recacheContainers() {
  clearCache();
  return cacheGanttContainers();
}
